import { render, staticRenderFns } from "./SquareBanners.vue?vue&type=template&id=4a73a261&scoped=true&"
import script from "./SquareBanners.vue?vue&type=script&lang=js&"
export * from "./SquareBanners.vue?vue&type=script&lang=js&"
import style0 from "./SquareBanners.vue?vue&type=style&index=0&id=4a73a261&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a73a261",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VImg,VSheet})
